import styled from 'styled-components';
import { Form } from 'antd';

// styled(Form) drops antd's generic `Form<Values>` call signature, which turns
// `onFinish`'s value param into `unknown`. Cast back to `typeof Form` so the
// component keeps antd's original typing (and static members) at the type level.
export const AntForm = styled(Form)`
  margin-bottom: -20px;

  .ant-form-item {
    margin-bottom: 24px;
  }

  &.ant-form-large .ant-form-item-label > label {
    height: 24px;
  }

  .ant-form-item-checkbox .ant-form-item-control-input {
    min-height: 24px;
  }
` as unknown as typeof Form;
